import { ProjectsListFilters } from 'types/store/projectsList';
import {
  QuickFilter,
  ACTIVE_PROJECTS_STATUSES,
  DATE_RANGE_FILTER_KEYS,
  isDateRangeFilterType,
} from 'utils/constants/projectsList';

interface ExportProjectsParams {
  quickFilters?: string[];
  filter?: ProjectsListFilters;
  search?: string;
  export?: {
    selectedProjectsIds?: string[];
    excludedProjectsIds?: string[];
  };
}

const BASE_URL = '/projects/exports/csv';

export const buildApiUrl = (params: ExportProjectsParams) => {
  const searchParams = new URLSearchParams();

  if (params.filter) {
    Object.entries(params.filter).forEach(([key, values]) => {
      if (Array.isArray(values)) {
        values.forEach((value) => {
          searchParams.append(`filter[${key}][]`, value.toString());
        });
        return;
      }

      if (DATE_RANGE_FILTER_KEYS.includes(key)) {
        if (isDateRangeFilterType(values)) {
          if (values.min) {
            searchParams.append(`filter[${key}][min]`, values.min as string);
          }
          if (values.max) {
            searchParams.append(`filter[${key}][max]`, values.max as string);
          }
        }
        return;
      }

      if (values) {
        searchParams.append(`filter[${key}]`, values as string);
      }
    });
  }

  if (params.quickFilters) {
    if (Array.isArray(params.quickFilters) && params.quickFilters.length > 0) {
      const openQuickFilterApplied = params.quickFilters.includes(
        QuickFilter.OPEN_PROJECTS
      );
      params.quickFilters.forEach((quickFilter) => {
        searchParams.append('quickFilter[]', quickFilter);
      });
      if (openQuickFilterApplied && !params.filter?.status) {
        ACTIVE_PROJECTS_STATUSES.forEach((status) => {
          searchParams.append('filter[status][]', status.toString());
        });
      }
    }
  }

  if (params.export) {
    if (
      params.export.selectedProjectsIds &&
      params.export.selectedProjectsIds.length > 0
    ) {
      params.export.selectedProjectsIds.forEach((projectId: string) =>
        searchParams.append('filter[id][include][]', projectId)
      );
    }

    if (
      params.export.excludedProjectsIds &&
      params.export.excludedProjectsIds.length > 0
    ) {
      params.export.excludedProjectsIds.forEach((projectId: string) =>
        searchParams.append('filter[id][exclude][]', projectId)
      );
    }
  }

  if (params.search) {
    searchParams.append('filter[name]', params.search);
    searchParams.append('filter[displayId]', params.search);
  }

  return `${BASE_URL}?${searchParams.toString()}`;
};
